export default __webpack_public_path__ + "static/media/867.bbe1f0fb.png";